import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer
      className="py-12 sm:py-14 border-t border-[color:var(--hairline)]"
      data-testid="footer"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 sm:gap-6">
          {/* Brand */}
          <div>
            <Link to="/" aria-label="MediaLabs Home">
              <img
                src="/medialabs-logo.jpg"
                alt="MediaLabs I.T. Solutions"
                className="h-12 sm:h-14 lg:h-16 w-auto object-contain"
                style={{ height: 'clamp(3rem, 3vw + 0.5rem, 4rem)' }}
                loading="lazy"
              />
            </Link>
            <p className="mt-3 text-xs text-muted-foreground leading-relaxed max-w-[220px]">
              AI-Powered Software Agency. V1 Apps in 15 days. Enterprise Websites in 2 days.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs font-bold text-foreground uppercase tracking-wider mb-3">Quick Links</h4>
            <nav className="space-y-2" aria-label="Footer quick links">
              <Link to="/services" className="block text-sm text-muted-foreground hover:text-foreground transition-colors duration-200" data-testid="footer-link-services">
                Services
              </Link>
              <Link to="/auth" className="block text-sm text-muted-foreground hover:text-foreground transition-colors duration-200" data-testid="footer-link-client-portal">
                Client Portal
              </Link>
              <Link to="/dashboard" className="block text-sm text-muted-foreground hover:text-foreground transition-colors duration-200" data-testid="footer-link-dashboard">
                Dashboard
              </Link>
              <a href="/#schedule" className="block text-sm text-muted-foreground hover:text-foreground transition-colors duration-200">
                Book a Call
              </a>
            </nav>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-xs font-bold text-foreground uppercase tracking-wider mb-3">Company</h4>
            <nav className="space-y-2" aria-label="Footer company links">
              <a href="/#how-it-works" className="block text-sm text-muted-foreground hover:text-foreground transition-colors duration-200">
                How It Works
              </a>
              <a href="/#industries" className="block text-sm text-muted-foreground hover:text-foreground transition-colors duration-200">
                Industries
              </a>
              <a href="/#speed-advantage" className="block text-sm text-muted-foreground hover:text-foreground transition-colors duration-200">
                Why MediaLabs
              </a>
              <Link to="/blog" className="block text-sm text-muted-foreground hover:text-foreground transition-colors duration-200" data-testid="footer-link-blog">
                Blog
              </Link>
            </nav>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-10 pt-6 border-t border-[color:var(--hairline)] text-center">
          <p className="text-xs text-muted-foreground">
            &copy; {new Date().getFullYear()} MediaLabs I.T. Solutions. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
